/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ILeagueModel, IMediaModel, RouteHelper } from "@bms/common";
import React from "react";
import { Link } from "react-router-dom";

export type ITableRow = NonNullable<ILeagueModel["Table"]>[number] & {
  Position: number;
};

interface ILeaguePlayerRowProps {
  row: ITableRow;
  hasMatchStats: boolean;
  hasGoals: boolean;
}

export const LeaguePlayerRow = ({
  row,
  hasMatchStats,
  hasGoals,
}: ILeaguePlayerRowProps) => {
  const playerName = [row.PlayerFirstName, row.PlayerLastName]
    .filter(Boolean)
    .join(" ");

  const playerLink =
    row.PlayerMediaId && row.PlayerMediaTypeCode
      ? RouteHelper.getDetailsPath({
          MediaTypeCode: row.PlayerMediaTypeCode,
          Id: row.PlayerMediaId,
        } as IMediaModel)
      : undefined;

  const teamLink =
    row.TeamMediaId && row.TeamMediaTypeCode
      ? RouteHelper.getDetailsPath({
          MediaTypeCode: row.TeamMediaTypeCode,
          Id: row.TeamMediaId,
        } as IMediaModel)
      : undefined;

  return (
    <tr>
      <td className="LeagueTableTab__col--pos">{row.Position}</td>
      <td className="LeagueTableTab__col--team">
        {playerLink ? (
          <Link to={playerLink} className="LeagueTableTab__link">
            {playerName || "—"}
          </Link>
        ) : (
          playerName || "—"
        )}
      </td>
      <td className="LeagueTableTab__col--team">
        {teamLink ? (
          <Link to={teamLink} className="LeagueTableTab__link">
            {row.TeamName ?? "—"}
          </Link>
        ) : (
          row.TeamName ?? "—"
        )}
      </td>
      {hasMatchStats && (
        <>
          <td className="LeagueTableTab__col--stat">
            {row.MatchesPlayed ?? "—"}
          </td>
          <td className="LeagueTableTab__col--stat">{row.Wins ?? "—"}</td>
          <td className="LeagueTableTab__col--stat">{row.Draws ?? "—"}</td>
          <td className="LeagueTableTab__col--stat">{row.Losses ?? "—"}</td>
        </>
      )}
      {hasGoals && (
        <td className="LeagueTableTab__col--goals">
          {row.GoalsScored ?? "—"}:{row.GoalsConceded ?? "—"}
        </td>
      )}
      <td className="LeagueTableTab__col--pts">{row.Points ?? "—"}</td>
    </tr>
  );
};
